module.exports = __webpack_public_path__ + "static/Pagu-Bar-Design-TN-7a223729841a87fa1fc392434f84d84f.jpg";